module.exports = __webpack_public_path__ + "img/p_16.ca1e4982.png";